import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect, useMemo } from "react";
import { Collapse, Typography, Divider, message, Row, Col, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import Meeting from '../../TablesAndTimelines/MeetingTable'
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload'
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts';
import { ScoreIcon } from '../../../../components/Icons/Icons';
import { accountInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, conditionApply, trigger }) => {
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const [userData, setUserData] = useState()
    const [accountData, setAccountData] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen3, setIsOpen3] = useState(true);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountData(params) {
        try {
            const responseData = await FetchAccountDetails(params)
            const Response = responseData.data
            const merged = { ...Response, DataPermission: { isPresent: responseData.allow }, };
            setAccountData(merged)
        } catch (error) {
            message.error(error)
        }
    }
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.account_owner && conditionApply && conditionApply === "Customer") {
                getUsersData(displayData?.account_owner)
            }
            else {
                setUserData()
            }
        }
    }, [displayData?.account_owner, isOpen4])
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.parent_organization) {
                getAccountData(displayData?.parent_organization)
            } else {
                setAccountData()
            }
        }
    }, [displayData?.parent_organization, isOpen2])
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await accountInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200) {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            {(conditionApply && conditionApply === "Customer") ? <>
                <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}> <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            minWidth: 0,
                        }}
                    >
                        <Text
                            strong
                            style={{
                                fontSize: 14,
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                            }}
                        >
                            Account Score
                        </Text>
                        <div className='Hover-Refresh3 back-hover2 able-style'
                            role="button"
                            tabIndex={0} title='View Score Insights'
                            onClick={(e) => {
                                e.stopPropagation();   // ✅ IMPORTANT
                                openScoreGeniee();
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.stopPropagation();
                                    openScoreGeniee()
                                }
                            }}
                            aria-label='insights'
                        ><ScoreIcon height={20} width={20} /></div>
                    </div>
                        <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                        {/* <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}> */}
                        <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                        {/* </div> */}
                    </Panel>
                </Collapse>
                <Divider style={{ margin: "10px 0" }} />
                <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
                <Divider style={{ margin: "10px 0" }} />
            </> : ""}
            {displayData?.parent_organization ? <>
                <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Parent Account</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                        {accountData ? <div className='RightSide-DataShadow'>
                            <div className={`user-info_image ${accountData?.DataPermission?.isPresent && "ListNavigate"}`}
                                style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                onClick={accountData?.DataPermission?.isPresent ? () => accountData?.account_id && ViewDetailPage(accountData?.account_id, "ACCOUNT") : undefined}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(accountData?.account_id, "ACCOUNT")
                                    }
                                }}
                            >
                                {accountData?.account_profile !== null && accountData?.account_profile
                                    !== undefined && accountData?.account_profile !== "" ?
                                    <figure>
                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={accountData?.account_profile} alt="" />
                                    </figure>
                                    :
                                    <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                        {accountData?.account_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <figcaption style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden", // 👈 keeps ellipsis responsive
                                }}>
                                    <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_name}>{accountData?.account_name}</div>
                                    <div style={{
                                        fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} title={accountData?.account_number}>{accountData?.account_number}</div>
                                </figcaption>
                            </div>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.industry_name && accountData?.industry_name !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                                            <br />
                                            <Text >{accountData?.industry_name}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.nom_of_employees && accountData?.nom_of_employees !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                                            <br />
                                            <Text >{accountData?.nom_of_employees}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                            <Row gutter={30}>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.annual_revenue && accountData?.annual_revenue !== "") ?
                                        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                            <Text >{accountData?.annual_revenue}</Text>
                                        </div> : <></>}</Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {(accountData?.rating && accountData?.rating !== "") ?
                                        <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                                            <Text >{accountData?.rating}</Text>
                                        </div> : <></>}
                                </Col>
                            </Row>
                        </div> : <div className='RightSide-DataShadow'>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "10rem"
                            }}>
                                <Spin />
                            </div>
                        </div>}
                    </Panel>
                </Collapse>
                <Divider style={{ margin: "10px 0" }} />
            </>
                : <></>}
            {(conditionApply && conditionApply === "Customer") ? <>
                <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                    <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Account Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                        <UserSideDiv userData={userData} />
                    </Panel>
                </Collapse >
                <Divider style={{ margin: "10px 0" }} />
            </> : ""}
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.account_files?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.account_files?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    conditionApply: PropTypes.string.isRequired,
    trigger: PropTypes.string.isRequired,
};
export default NoteDetails;
